import React from "react";
import PropTypes from "prop-types";
import FooterMainFlowerStyled from "./FooterMainFlower.styled";
import { Link, useLocation } from "react-router-dom";
import SVGIcon from "../utility/SVGIcon";
import EmailSubcriptionCTAFlower from "../EmailSubscriptionCTA/EmailSubcriptionCTAFlower/EmailSubcriptionCTAFlower";
import { storeType, storeName } from "../../config/constants";
import LogoLogickit from "../../images/LK_Logo2.png";

const FooterMainFlower = React.memo(props => {
  const { license_number, simple } = props
  const year = new Date();
  const currentYear = year.getFullYear();
  const { pathname } = useLocation();
  const isSEOLocationPAge = pathname.includes("/cannabis-delivery-");

  return (
    <>
    <FooterMainFlowerStyled simple={simple} data-testid="footerMain">
      {!simple && !isSEOLocationPAge &&
        <EmailSubcriptionCTAFlower />
      }
      <div className="footer-wrap">
        {!simple && storeType === 'rebud' &&
          <SVGIcon name="flower-footer-logo" className="footer-home__logo" />
        }

        <ul className="footer-home__links">
          {/*<li className="footer-home__link">*/}
          {/*  <Link to="/about" className="t-footer-flower">About</Link>*/}
          {/*</li>*/}
          <li className="footer-home__link">
            <Link to="/contact" className="t-footer-flower">Contact Us</Link>
          </li>
          {/*<li className="footer-home__link">*/}
          {/*  <Link to="/faq" className="t-footer-flower">FAQ</Link>*/}
          {/*</li>*/}
          <li className="footer-home__link">
            <Link to="/privacy" className="t-footer-flower">Privacy Policy</Link>
          </li>
          <li className="footer-home__link">
            <Link to="/terms" className="t-footer-flower">Terms</Link>
          </li>
        </ul>

        {/*<ul className="footer-home__socials">*/}
        {/*  <li className="footer-home__social">*/}
        {/*    <a href="https://twitter.com/RebudOfficial" className="t-footer-flower">*/}
        {/*      <span className="t-hidden">Twitter</span>*/}
        {/*      <SVGIcon name="twitter" />*/}
        {/*    </a>*/}
        {/*  </li>*/}
        {/*  <li className="footer-home__social">*/}
        {/*    <a href="https://www.instagram.com/rebudofficial" className="t-footer-flower">*/}
        {/*      <span className="t-hidden">Instagram</span>*/}
        {/*      <SVGIcon name="instagram" />*/}
        {/*    </a>*/}
        {/*  </li>*/}
        {/*</ul>*/}

        <p className="t-body-flower footer-home__copywrite">Copyright &copy; {currentYear} {storeName}, all rights reserved.</p>
        {license_number &&
          <p className="t-body-flower footer-home__license">Store license number: {license_number}.</p>
        }
        <a href="https://www.logickit.io/" target="_blank" className="t-body footer-home__license d-flex-container">
          Powered by &nbsp; <img src={LogoLogickit} height={20} alt="logo"/>
        </a>
      </div>
    </FooterMainFlowerStyled>
    </>
  );
});

FooterMainFlower.propTypes = {
  license_number: PropTypes.string,
  simple: PropTypes.bool
};

export default FooterMainFlower;
